/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useIntl } from 'react-intl-next';

import { jsx } from '@atlaskit/css';
import { RovoIcon } from '@atlaskit/logo';
import { Box, Inline, Text } from '@atlaskit/primitives/compiled';

import messages from '../messages';
import { type AIBrand } from '../types';

export interface FooterAIBrandProps {
	/** The appearance of main footer. */
	appearance: 'small' | 'medium' | 'large';
	/** The brand to display */
	brand: AIBrand;
}

export function FooterAIBrand({ appearance }: FooterAIBrandProps) {
	const { formatMessage } = useIntl();
	return (
		<Inline>
			{appearance !== 'small' && (
				<Box>
					<Text size="small" color="color.text.subtle">
						{formatMessage(messages.rovoCopyright)}
					</Text>
				</Box>
			)}
			<RovoIcon label={formatMessage(messages.rovoCopyright)} appearance="neutral" size="small" />
		</Inline>
	);
}
